import React, { useEffect, useState } from "react";
import DashBoardHeader from "../../../Components/interface/DashBoardHeader";
import styles from "./LiveMetrics.module.css";
// import { Gauge } from "@ant-design/plots";
import SpeedMetrics from "../../../Components/interface/SpeedMetrics";

function LiveMetrics() {
  // let [fig, setFig] = useState(null);
  let [fuelHeight, setFuelHeight] = useState(null);
  let [color, setColor] = useState(null);
  let [bColor, setbColor] = useState(null);
  useEffect(() => {
    if (fuelHeight <= `${20}%`) {
      setColor("#FD4D1E");
      setbColor("#FFE5D3");
    } else if (fuelHeight <= `${50}%`) {
      setColor("#FFB200");
      setbColor("#FFF5CC");
    }
    if (fuelHeight > `${50}%`) {
      setColor("#0AB34E");
      setbColor("#E2FBD7");
    }
    if (fuelHeight === `${100}%`) {
      setColor("#0AB34E");
      setbColor("#E2FBD7");
    }
  }, [fuelHeight]);

  useEffect(() => {
    // const config = {
    //   percent: 0.03,

    //   range: {
    //     ticks: [0, 1 / 3, 2 / 3, 1],
    //     color: ["#F4664A", "#FAAD14", "#30BF78"],
    //   },
    //   indicator: {
    //     pointer: {
    //       style: {
    //         stroke: "#D0D0D0",
    //       },
    //     },
    //     pin: {
    //       style: {
    //         stroke: "#D0D0D0",
    //       },
    //     },
    //   },
    //   statistic: {
    //     content: {
    //       style: {
    //         marginTop: "5px",
    //         fontSize: "10px",
    //         lineHeight: "20px",
    //       },
    //     },
    //   },
    //   axis: {
    //     label: {
    //       style: {
    //         fontSize: 10,
    //       },
    //     },
    //   },
    // };

    let barFillHeight = `${50}%`;
    setFuelHeight(barFillHeight);
    // setFig(config);
  }, []);

  return (
    <div className={styles.liveMetrics}>
      <DashBoardHeader title="Live Metrics" />
      <SpeedMetrics />
      <div className={styles.liveMetrics__inner_body}>
        <div className={styles.liveMetrics__inner_body_content}>
          <div className={styles.liveMetrics__inner_body_content_body}>
            <svg
              width="48"
              height="68"
              viewBox="0 0 48 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="47"
                height="67"
                rx="7.5"
                fill={bColor}
                stroke={bColor}
              />
              <path
                d="M0.5 6.5H47.5V60C47.5 64.1421 44.1421 67.5 40 67.5H8C3.85787 67.5 0.5 64.1421 0.5 60V6.5Z"
                fill={color}
                stroke={color}
              />
            </svg>

            <p>Fuel Guage</p>
          </div>

          <div className={styles.liveMetrics__inner_body_content_body}>
            <svg
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_2049_8510" fill="white">
                <path d="M21.8333 26.666H43.1666V47.9994H29.8333L24.5 42.666H19.1666V29.3327M19.1666 10.666V15.9993H27.1666V21.3327H19.1666L13.8333 26.666V34.666H8.49996V26.666H3.16663V47.9994H8.49996V39.9994H13.8333V47.9994H21.8333L27.1666 53.3327H48.5V42.666H53.8333V50.666H61.8333V23.9994H53.8333V31.9994H48.5V21.3327H32.5V15.9993H40.5V10.666H19.1666Z" />
              </mask>
              <path
                d="M43.1666 26.666H45.1666V24.666H43.1666V26.666ZM43.1666 47.9994V49.9994H45.1666V47.9994H43.1666ZM29.8333 47.9994L28.4191 49.4136L29.0049 49.9994H29.8333V47.9994ZM24.5 42.666L25.9142 41.2518L25.3284 40.666H24.5V42.666ZM19.1666 42.666H17.1666V44.666H19.1666V42.666ZM19.1666 10.666V8.66602H17.1666V10.666H19.1666ZM19.1666 15.9993H17.1666V17.9993H19.1666V15.9993ZM27.1666 15.9993H29.1666V13.9993H27.1666V15.9993ZM27.1666 21.3327V23.3327H29.1666V21.3327H27.1666ZM19.1666 21.3327V19.3327H18.3382L17.7524 19.9185L19.1666 21.3327ZM13.8333 26.666L12.4191 25.2518L11.8333 25.8376V26.666H13.8333ZM13.8333 34.666V36.666H15.8333V34.666H13.8333ZM8.49996 34.666H6.49996V36.666H8.49996V34.666ZM8.49996 26.666H10.5V24.666H8.49996V26.666ZM3.16663 26.666V24.666H1.16663V26.666H3.16663ZM3.16663 47.9994H1.16663V49.9994H3.16663V47.9994ZM8.49996 47.9994V49.9994H10.5V47.9994H8.49996ZM8.49996 39.9994V37.9994H6.49996V39.9994H8.49996ZM13.8333 39.9994H15.8333V37.9994H13.8333V39.9994ZM13.8333 47.9994H11.8333V49.9994H13.8333V47.9994ZM21.8333 47.9994L23.2475 46.5851L22.6617 45.9994H21.8333V47.9994ZM27.1666 53.3327L25.7524 54.7469L26.3382 55.3327H27.1666V53.3327ZM48.5 53.3327V55.3327H50.5V53.3327H48.5ZM48.5 42.666V40.666H46.5V42.666H48.5ZM53.8333 42.666H55.8333V40.666H53.8333V42.666ZM53.8333 50.666H51.8333V52.666H53.8333V50.666ZM61.8333 50.666V52.666H63.8333V50.666H61.8333ZM61.8333 23.9994H63.8333V21.9994H61.8333V23.9994ZM53.8333 23.9994V21.9994H51.8333V23.9994H53.8333ZM53.8333 31.9994V33.9994H55.8333V31.9994H53.8333ZM48.5 31.9994H46.5V33.9994H48.5V31.9994ZM48.5 21.3327H50.5V19.3327H48.5V21.3327ZM32.5 21.3327H30.5V23.3327H32.5V21.3327ZM32.5 15.9993V13.9993H30.5V15.9993H32.5ZM40.5 15.9993V17.9993H42.5V15.9993H40.5ZM40.5 10.666H42.5V8.66602H40.5V10.666ZM21.8333 28.666H43.1666V24.666H21.8333V28.666ZM41.1666 26.666V47.9994H45.1666V26.666H41.1666ZM43.1666 45.9994H29.8333V49.9994H43.1666V45.9994ZM31.2475 46.5851L25.9142 41.2518L23.0857 44.0802L28.4191 49.4136L31.2475 46.5851ZM24.5 40.666H19.1666V44.666H24.5V40.666ZM21.1666 42.666V29.3327H17.1666V42.666H21.1666ZM17.1666 10.666V15.9993H21.1666V10.666H17.1666ZM19.1666 17.9993H27.1666V13.9993H19.1666V17.9993ZM25.1666 15.9993V21.3327H29.1666V15.9993H25.1666ZM27.1666 19.3327H19.1666V23.3327H27.1666V19.3327ZM17.7524 19.9185L12.4191 25.2518L15.2475 28.0802L20.5808 22.7469L17.7524 19.9185ZM11.8333 26.666V34.666H15.8333V26.666H11.8333ZM13.8333 32.666H8.49996V36.666H13.8333V32.666ZM10.5 34.666V26.666H6.49996V34.666H10.5ZM8.49996 24.666H3.16663V28.666H8.49996V24.666ZM1.16663 26.666V47.9994H5.16663V26.666H1.16663ZM3.16663 49.9994H8.49996V45.9994H3.16663V49.9994ZM10.5 47.9994V39.9994H6.49996V47.9994H10.5ZM8.49996 41.9994H13.8333V37.9994H8.49996V41.9994ZM11.8333 39.9994V47.9994H15.8333V39.9994H11.8333ZM13.8333 49.9994H21.8333V45.9994H13.8333V49.9994ZM20.4191 49.4136L25.7524 54.7469L28.5808 51.9185L23.2475 46.5851L20.4191 49.4136ZM27.1666 55.3327H48.5V51.3327H27.1666V55.3327ZM50.5 53.3327V42.666H46.5V53.3327H50.5ZM48.5 44.666H53.8333V40.666H48.5V44.666ZM51.8333 42.666V50.666H55.8333V42.666H51.8333ZM53.8333 52.666H61.8333V48.666H53.8333V52.666ZM63.8333 50.666V23.9994H59.8333V50.666H63.8333ZM61.8333 21.9994H53.8333V25.9994H61.8333V21.9994ZM51.8333 23.9994V31.9994H55.8333V23.9994H51.8333ZM53.8333 29.9994H48.5V33.9994H53.8333V29.9994ZM50.5 31.9994V21.3327H46.5V31.9994H50.5ZM48.5 19.3327H32.5V23.3327H48.5V19.3327ZM34.5 21.3327V15.9993H30.5V21.3327H34.5ZM32.5 17.9993H40.5V13.9993H32.5V17.9993ZM42.5 15.9993V10.666H38.5V15.9993H42.5ZM40.5 8.66602H19.1666V12.666H40.5V8.66602Z"
                fill="#4FB128"
                mask="url(#path-1-inside-1_2049_8510)"
              />
            </svg>

            <p>Eng Load</p>
          </div>

          <div className={styles.liveMetrics__inner_body_content_body}>
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 11H15V12V16V17H8H7V18V54V55H8H56H57V54V18V17H56H49V16V12V11H48H40H39V12V16V17H25V16V12V11H24H16ZM40 29H39V30V33H36H35V34V38V39H36H39V42V43H40H44H45V42V39H48H49V38V34V33H48H45V30V29H44H40ZM16 33H15V34V38V39H16H28H29V38V34V33H28H16ZM13 23H51V49H13V23Z"
                stroke="#0AB34E"
                stroke-width="2"
              />
            </svg>

            <p>Battery </p>
          </div>
        </div>
        <div className={styles.liveMetrics__inner_body_content}>
          <div className={styles.liveMetrics__inner_body_content_body}>
            <svg
              width="59"
              height="58"
              viewBox="0 0 49 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 24C3.5 29.8 5.86 35 9.66 38.84L7.5 41C3.18 36.62 0.5 30.62 0.5 24C0.5 17.38 3.18 11.38 7.5 7.00005L9.66 9.16005C5.86 13 3.5 18.22 3.5 24ZM42.5 24C42.4997 28.7742 40.603 33.3527 37.2269 36.7284C33.8509 40.104 29.2722 42.0003 24.498 42C19.7238 41.9998 15.1453 40.103 11.7697 36.727C8.39401 33.3509 6.49774 28.7722 6.498 23.998C6.49827 19.2239 8.39505 14.6454 11.7711 11.2697C15.1471 7.89406 19.7258 5.99778 24.5 5.99805C29.2742 5.99831 33.8527 7.89509 37.2283 11.2711C40.604 14.6472 42.5003 19.2259 42.5 24ZM10.5 24C10.5 24.88 10.6 25.72 10.74 26.56C11.1 26.18 11.42 26 12.06 26C13.1 26 13.28 26.42 14.06 27.42C14.84 28.42 16.2 30 18.28 30C20.34 30 21.72 28.42 22.5 27.42C23.02 26.74 23.28 26.36 23.72 26.16C23.92 26.06 24.16 26 24.5 26C25.5 26 25.72 26.42 26.5 27.42C27.28 28.42 28.66 30 30.72 30C32.8 30 34.16 28.42 34.94 27.42C35.72 26.42 35.9 26 36.94 26C37.58 26 37.9 26.18 38.26 26.56C38.4 25.72 38.5 24.88 38.5 24C38.5 16.28 32.22 10 24.5 10C16.78 10 10.5 16.28 10.5 24ZM41.5 7.00005L39.34 9.16005C43.14 13 45.5 18.22 45.5 24C45.5 29.8 43.14 35 39.34 38.84L41.5 41C45.82 36.62 48.5 30.62 48.5 24C48.5 17.38 45.82 11.38 41.5 7.00005Z"
                fill="#FFB200"
              />
            </svg>

            <p>Brake Fluid </p>
          </div>

          <div className={styles.liveMetrics__inner_body_content_body}>
            <svg
              width="59"
              height="58"
              viewBox="0 0 49 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M48.5 24C48.5 30.62 45.82 36.62 41.5 41L39.34 38.84C43.14 35 45.5 29.8 45.5 24C45.5 18.22 43.14 13 39.34 9.16L41.5 7C45.82 11.38 48.5 17.38 48.5 24ZM40.5 19.2V16H34.1C32.34 16 30.9 17.44 30.9 19.2V22.4C30.9 23.2487 31.2371 24.0626 31.8373 24.6627C32.4374 25.2629 33.2513 25.6 34.1 25.6H37.3V28.8H30.9V32H37.3C39.06 32 40.5 30.56 40.5 28.8V25.6C40.5 24.7513 40.1629 23.9374 39.5627 23.3373C38.9626 22.7371 38.1487 22.4 37.3 22.4H34.1V19.2H40.5ZM17.34 12C19.44 10.74 21.88 10 24.5 10C27.12 10 29.56 10.74 31.66 12H37.88C34.6 8.32 29.82 6 24.5 6C19.18 6 14.4 8.32 11.12 12H17.34ZM26.9 24C28.18 24 29.3 25.12 29.3 26.4V28.8C29.3 29.2202 29.2172 29.6363 29.0564 30.0246C28.8956 30.4128 28.6599 30.7656 28.3627 31.0627C28.0656 31.3599 27.7128 31.5956 27.3246 31.7564C26.9363 31.9172 26.5202 32 26.1 32H19.7V16H26.1C26.9487 16 27.7626 16.3371 28.3627 16.9373C28.9629 17.5374 29.3 18.3513 29.3 19.2V21.6C29.3 22.88 28.18 24 26.9 24M26.1 25.6H22.9V28.8H26.1V25.6ZM26.1 19.2H22.9V22.4H26.1V19.2M9.66 9.16L7.5 7C3.18 11.38 0.5 17.38 0.5 24C0.5 30.62 3.18 36.62 7.5 41L9.66 38.84C5.86 35 3.5 29.8 3.5 24C3.5 18.22 5.86 13 9.66 9.16ZM14.9 32V25.6H11.7V32H8.5V19.2C8.5 18.3513 8.83714 17.5374 9.43726 16.9373C10.0374 16.3371 10.8513 16 11.7 16H14.9C16.66 16 18.1 17.44 18.1 19.2V32H14.9ZM14.9 22.4V19.2H11.7V22.4H14.9M31.66 36C29.56 37.26 27.12 38 24.5 38C21.9757 37.9978 19.5 37.3062 17.34 36H11.12C14.4 39.68 19.18 42 24.5 42C29.82 42 34.6 39.68 37.88 36H31.66V36Z"
                fill="#FFB200"
              />
            </svg>

            <p>Brake ABS</p>
          </div>
          <div className={styles.liveMetrics__inner_body_content_body}>
            {/* <Gauge {...fig} /> */}
            <h3>Temperature</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveMetrics;
